import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import LightBootstrap from './light-bootstrap-main'
// Plugins
import App from './App.vue'

// router setup
import routes from './routes/routes'

// plugins setup
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(LightBootstrap)

// configure axios base URL
if (process.env.NODE_ENV === 'production') {
  const Env = require('./utils/config/prod.env.json')
  axios.defaults.baseURL = Env.API_URL
} else {
  const Env = require('./utils/config/dev.env.json')
  axios.defaults.baseURL = Env.API_URL
}

// configure default axios response on error 401.
axios.interceptors.response.use(null, function (error) {
  const res = error.response
  if (res.status === 401) {
    window.alert('Sessão expirada! Realize o login novamente.')
    window.alert = function () {}
    location.reload()
  }
  return Promise.reject(error)
})

// configure router
const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

Vue.router = router

// configure vue-auth with the @websanova package
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: { path: 'login' }
})

// init app
App.router = Vue.router
new Vue(App).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js